import React from 'react';
import PropTypes from 'prop-types';

export default function BasicPortlet({
  title,
  subtitle,
  children,
  titleClass,
  toolAnchor,
  toolTitle,
  toolClass,
  isButton,
  showBtn,
  customTools,
  disabled,
}) {
  return (
    <div className="m-portlet m-portlet--mobile">
      <div className="m-portlet__head">
        <div className="m-portlet__head-caption">
          <div className="m-portlet__head-title">
            <h3 className={`m-portlet__head-text ${titleClass || ''}`}>
              {title}
              {subtitle && <small>{subtitle}</small>}
            </h3>
          </div>
        </div>
        <div className="m-portlet__head-tools">
          {customTools ? (
            <>{customTools}</>
          ) : (
            <>
              {!isButton ? (
                <a
                  style={
                    disabled
                      ? { pointerEvents: 'none', opacity: 0.6 }
                      : undefined
                  }
                  href={toolAnchor}
                  className={toolClass}
                >
                  {toolTitle}
                </a>
              ) : (
                showBtn && (
                  <button
                    disabled={disabled}
                    type="button"
                    className={toolClass}
                    onClick={toolAnchor}
                  >
                    {toolTitle}
                  </button>
                )
              )}
            </>
          )}
        </div>
      </div>
      <div className="m-portlet__body">{children}</div>
    </div>
  );
}

BasicPortlet.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  titleClass: PropTypes.string,
  toolAnchor: PropTypes.string,
  toolTitle: PropTypes.string,
  toolClass: PropTypes.string,
  isButton: PropTypes.bool,
  showBtn: PropTypes.bool,
  customTools: PropTypes.node,
  disabled: PropTypes.bool,
};

BasicPortlet.defaultProps = {
  subtitle: null,
  titleClass: null,
  toolAnchor: null,
  toolTitle: null,
  toolClass: null,
  isButton: false,
  showBtn: true,
  customTools: null,
  disabled: false,
};
